export const ANSWER_STATUS = [
    { label: 'Unanswered', value: 'unanswerable', color: 'text-[#DC6803]' },
    { label: 'Incorrect', value: 'incorrect', color: 'text-[#D92D20]' },
    { label: 'Not Relevant', value: 'not-relevant', color: 'text-[#8E1108]' },
    { label: 'Low Relevance', value: 'low-relevance', color: 'text-[#8E1108]' },
]